import './CompanyInfo.css';

const CompInfo = () => {
  return (
    <div className="services-container">
      <div className="info-section">        
        <div className="services-section">
          <div className="service-panel residential">
            <div className="service-content">
              <h2>Service Calls</h2>
              <p>Encountering an electrical issue can be a significant inconvenience. Rest assured, our expert team is ready to assist you. Regardless of the scale, from minor repairs to substantial projects, we approach every task with the same level of meticulous care and professionalism. Allow us to address your electrical concerns efficiently and effectively.</p>
              <a href="/services" className="service-link">
                <div className="circle-icon">
                  <span>→</span>
                </div>
              </a>
            </div>
          </div>
          
          <div className="service-panel commercial">
            <div className="service-content">
              <h2>New Construction</h2>
              <p>Whether you're embarking on a renovation, remodeling venture, or undertaking a new construction project, Escudero Electrical Contractors LLC is equipped to meet all your electrical needs. We are committed to delivering top-tier service for projects of any size, ensuring meticulous attention to detail and unwavering diligence characteristic of our reputation.</p>
              <a href="/services" className="service-link">
                <div className="circle-icon">
                  <span>→</span>
                </div>
              </a>
            </div>
          </div>
          
          <div className="service-panel safety">
            <div className="service-content">
              <h2>Industrial</h2>
              <p>For industrial-grade electrical services, look no further than Escudero Electrical Contractors LLC. Our team is fully equipped to handle the complex demands of industrial settings. Contact us to discover how we can assist you with your specific requirements and ensure your project's success with our expert solutions.</p>
              <a href="/services" className="service-link">
                <div className="circle-icon">
                  <span>→</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        
        <h1>YOUR PREMIER SOURCE FOR COMPREHENSIVE ELECTRICAL SERVICES: FROM UPGRADES TO INSTALLATIONS AND BEYOND</h1>
        <p>At Escudero Electrical Contractors LLC, we are a locally-owned family business with over three decades of experience. Our dedication lies in ensuring every client's complete satisfaction. Regardless of the project size, we believe every task is significant. Rest assured, we're in your corner.</p>
        
        <a href='/about'>
          <button className="about-us-button">About Us</button>
        </a>
      </div>
    </div>
  );
};

export default CompInfo;